import "core-js/modules/es.array.includes";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { renderMarkdown } from 'helpers/markdown';
import { isBlank } from 'helpers/verify';
import { Heading } from 'components/Heading/Heading';
import { InterpolateVariables } from 'providers/ContextVariables';
var ALIGNMENTS = ['left', 'center', 'right'];
var TITLE_SIZES = ['regular', 'medium', 'large', 'huge', 'header-small', 'header', 'header-large', 'display-tiny', 'display-small', 'display', 'display-large'];
export var HeadingTag = function HeadingTag(_ref) {
  var className = _ref.className,
      title = _ref.title;
  return React.createElement(InterpolateVariables, null, function (interpolator) {
    return React.createElement(Heading, {
      className: className
    }, renderMarkdown(interpolator(title), "CmsHeading__".concat(title)));
  });
};
export var CmsHeading = function CmsHeading(_ref2) {
  var _classNames;

  var alignment = _ref2.alignment,
      size = _ref2.size,
      title = _ref2.title;

  if (isBlank(title)) {
    return null;
  }

  var headerClasses = classNames((_classNames = {
    CmsHeading: true
  }, _defineProperty(_classNames, "CmsHeading--align-".concat(alignment), ALIGNMENTS.includes(alignment)), _defineProperty(_classNames, "CmsHeading--size-".concat(size), TITLE_SIZES.includes(size)), _classNames));
  return React.createElement("header", {
    className: headerClasses
  }, React.createElement(HeadingTag, {
    className: "CmsHeading__title",
    title: title
  }));
};
HeadingTag.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string
};
CmsHeading.propTypes = {
  alignment: PropTypes.oneOf(ALIGNMENTS),
  size: PropTypes.oneOf(TITLE_SIZES),
  title: PropTypes.string
};